import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true, name: 'processPipe'
})
export class ProcessPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'DEFAULT_PROCESS': return 'Default Process'
      case 'NORMAL': return 'Normal Process'
      case 'OPEN_PROCESS': return 'Open Process'
      case 'ACCEPTED_PROCESS': return 'Accepted Process'
      case 'REJECTED_PROCESS': return 'Rejected Process'
      case 'ON_HOLD_PROCESS': return 'On-Hold Process'
      case 'CLOSED_PROCESS': return 'Closed Process'
      case 'APPEAL_PROCESS': return 'Appeal Process'
      case 'DROP_PROCESS': return 'Dropped Process'
      default: return value;
    }
  }
}